module.exports = __webpack_public_path__ + "static/media/bvicam_logo.e7fbc0db.png";